import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { enUS, fr, ar, ru, kk } from 'date-fns/locale'
import { i18nextPlugin as showTranslationsPlugin } from 'translation-check'

import frenchTranslationFile from './fr/french.json'
import englishTranslationFile from './en/english.json'
import arabicTranslationFile from './ar/arabic.json'
import russianTranslationFile from './ru-RU/russian.json'
import kazakhTranslationFile from './kk-KZ/kazakh.json'

export const dateFnsLocales = {
  en: enUS,
  fr,
  ar,
  'ru-RU': ru,
  'kk-KZ': kk,
}

export const resources = {
  fr: {
    translation: frenchTranslationFile,
  },
  en: {
    translation: englishTranslationFile,
  },
  ar: {
    translation: arabicTranslationFile,
  },
  'ru-RU': {
    translation: russianTranslationFile,
  },
  'kk-KZ': {
    translation: kazakhTranslationFile,
  },
} as const

// 'ru' was the legacy locale key for Russian; migrate stored preference to 'ru-RU'
const storedLanguage = localStorage.getItem('language')

i18n
  .use(initReactI18next)
  .use(showTranslationsPlugin)
  .init({
    resources,
    lng: (storedLanguage === 'ru' ? 'ru-RU' : storedLanguage) ?? 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss injection
    },
    parseMissingKeyHandler: (path: string) => {
      if (process.env.NODE_ENV === 'development')
        return `{{${i18n.language}:${path}}}`

      const index = path.lastIndexOf('.') + 1
      return path.slice(index).replace(/_/g, ' ')
    },
  })
  .catch(err => console.warn(err))
